<template>
    <div class="padding_side">
        <div class="item_wrap">
            <div class="item_category_wrap ">
                <button class="item_category" :class="{'active':filterCategory.length === 0}" @click="selectCategory('')">
                    {{$t('all')}}
                </button>
                <button class="item_category" :class="{'active':filterCategory[0] === data.node_id}"
                        @click="selectCategory(data.node_id)" v-for="data in itemCategoryList"
                        :key="`categort${data.node_id}`"> {{ returnCategoryName(data) }}
                </button>
            </div>
        </div>
        <div class="competition_wrap pb17 ">
            <div class="competition_item application_item">
                <div class="competition_input">
                    <el-input :placeholder="$t('st')" v-model="searchInput" @keypress.native.enter="setFilterFunc(searchInputOption,searchInput)"></el-input>
                    <button class="competition_btn" @click="setFilterFunc(searchInputOption,searchInput)"></button>
                </div>
            </div>
            <div class="competition_btn_wrap">
                <button class="c_sort_btn ma0" @click="openFilter('gallery-item-sort-filter')"></button>
                <button class="c_filter_btn ma0 ml13"  @click="openFilter('item-filter-item-add-filter')"></button>
            </div>
            <div class="clear"></div>
        </div>
<!--        <div class="search_item mb19">
            <div class="search_input detection_search_input">
                <el-input :placeholder="$t('st')" v-model="searchInput"
                          @keypress.enter.native="setFilterFunc(searchInputOption,searchInput)"></el-input>
                <button class="search_btn mypage_search_btn" @click="setFilterFunc(searchInputOption,searchInput)"></button>
            </div>
            <button class="search_filter_btn" @click="openFilter('item-filter-item-add-filter')"></button>
        </div>-->
        <item-filter-item-add-filter></item-filter-item-add-filter>
        <gallery-item-sort-filter></gallery-item-sort-filter>
    </div>
</template>

<script>
import util from "@/mixins/util";
import itemUtil from "@/components/item/itemUtil";
import ItemFilterItemAddFilter from "@/components/filter/ItemFilterItemAddFilter";
import GalleryItemSortFilter from "@/components/sort/GalleryItemSortFilter";
import {mapState} from "vuex";

const {filterConfig} = itemUtil
export default {
    name: "ItemFilterGalleryLayout",
    mixins: [itemUtil],
    components: {
        ItemFilterItemAddFilter,
        GalleryItemSortFilter
    },
    inject: ['setFilter', 'setSort'],
    provide() {
        return {}
    },
    props: {
        filterData: {
            default: () => {
            }
        },
        sortData: {
            type: Object,
            default: () => {
            }
        },
    },
    data() {
        return {
            searchInputOption: 'ina',
            sort: '',
            sortOption: 'last_update',
            searchInput: '',
            filterCategory: [],
            filterBidStatus: [],
            filterStatus: [],
            filterDate: [],
            filterEdition: [],
            filterType: [],
            priceInput: ['', ''],
        }
    },
    beforeRouterEnter() {
    },
    created() {
        this.setterFilterDataInData();

    },
    mounted() {

    },
    beforeDestroy() {
    },
    destroyed() {
    },
    computed: {
        ...mapState({
            itemCategoryList: state => state.itemCategory.itemCategoryList,
        })
    },
    methods: {
        openFilter(name) {
            this.$modal.show(name, {sortData: this.sortData, filterData: this.filterData});
        },
        setterFilterDataInData() {
            let classnames = Object.keys(this.filterData);
            classnames.forEach(classname => {
                let obj = this.filterData[classname];
                let type = filterConfig[obj.key].type;
                if (this.hasOwnProperty(classname)) {
                    if (type == 'query') {
                        this[classname] = obj.query;
                        if (this.hasOwnProperty(classname + 'Option')) {
                            this[classname + 'Option'] = obj.key;
                        }
                    } else if (type === 'between') {
                        this[classname] = [obj.start, obj.end];
                    } else if (type === 'match') {
                        if (isNaN(obj.value)) {
                            this[classname] = obj.value;
                        } else {
                            this[classname] = Number(obj.value);
                        }

                    } else if (type === 'terms') {
                        this[classname] = obj.terms;
                    }

                }
            })
        },
        setFilterFunc(key, value) {
            this.setFilter(key, value);
        },
        setData(key, value) {
            this[key] = value;
        },
        changeFilter() {
            if (this.priceInput[1] !== '' && this.priceInput[0] > this.priceInput[1]) {
                return
            }
            this.setFilterFunc('pr', this.priceInput);
        },
        changeDateFilter() {
            if (util.isEmpty(this.filterDate)) {
                this.setFilter('cr', '');
            } else {
                let date = this.filterDate;
                date[0] = `${date[0]} 00:00:00`;
                date[1] = `${date[1]} 23:59:59`;
                this.setFilter('cr', date);
            }
        },
        returnCategoryName(data) {
            let locale = this.$i18n.locale;
            if (locale === 'ko') {
                return data.NAME
            }
            return data.NAME_ENG
        },
        selectCategory(value) {
            if (value == '') {
                this.filterCategory = [];
            } else {
                this.filterCategory = [value];
            }
            this.setFilterFunc('ic', this.filterCategory);
        },
    },
    watch: {},
}
</script>

<style scoped>

</style>
